export enum BorderType {
    FLOOR_CHANGE = "FLOOR_CHANGE",
    ROOF_CHANGE = "ROOF_CHANGE",
}

export const BORDER_TYPE_OPTIONS = [
    { value: BorderType.FLOOR_CHANGE, label: 'Změna  podlahy', selected: true, externalId: 0 },
    { value: BorderType.ROOF_CHANGE, label: 'Změna střechy', selected: false, externalId: 1 },
];
